import React from "react";

export default function NotFound() {
  return (
    <div>
      <p>404 Page not found</p>
    </div>
  );
}
